export enum MediaserverVideoSetting {
  MediaserverVideoDisabled = 'MediaserverVideoDisabled',
  MediaserverVideoEnabled = 'MediaserverVideoEnabled',
}
